module.exports = __webpack_public_path__ + "fae809850b01e08b7bd741f6713b72ba.svg";